import React from 'react'
import Heading from '../../../component/common/Heading'
import { Card, Row } from 'antd'
import CRUDComponent from '../../../component/common/CRUD-Component'
import CONSTANTS from '../../../util/constant/CONSTANTS'
import { convertUTCToLocal } from '../../../util/functions'

const LocationHistory = ({ id }) => {
    return (
        <>
            <Card>
                <Heading>Location History</Heading>

                <Row>
                    <CRUDComponent
                        GET={{
                            API: CONSTANTS.API.Location_history.getAll,
                            extraQuery: {
                                petId: id
                            },
                            DataModifier: (res, API, Setrefresh) => {
                                // console.log(res, "GET ALL ABCD");
                                return res?.map(data => {
                                    return {
                                        ...data,
                                        no: `LH${data?.id.toString().padStart(7, "0")}`,
                                        name: data?.Admin?.name,
                                        email: data?.Admin?.email,
                                        role: data?.Admin?.role,
                                        date: convertUTCToLocal(data?.createdAt, 'DD MMM YYYY hh:mm A'),

                                    }
                                })
                            },
                            column: CONSTANTS.TABLE.PET_LOCATION_HISTORY_LIST,
                        }}
                        isSearch={true}

                    />
                </Row>

            </Card>
        </>
    )
}

export default LocationHistory